elem.sections.photos.addEventListener('click', event => {
    const photoElem = event.target;
    if (photoElem.classList.contains('photo')) {
        if (elem.currentPhoto) {
            if (elem.currentPhoto.id !== photoElem.id) {
                const prevPhotoElem = elem.currentPhoto;
                prevPhotoElem.classList.remove('selected');
                prevPhotoElem.style.transform = 'unset';
                setTimeout(() => {
                    prevPhotoElem.classList.remove('front');
                }, 2200);
            }
        }
        if (photoElem.classList.contains('selected')) {
            msa.unselectPhoto(photoElem);
        } else {
            msa.selectPhoto(photoElem);
        }
    }
});

elem.menu.addEventListener('click', event => {
    if (event.target.classList.contains('filter')) {
        const isAdd = event.target.classList.toggle('selected'),
           doFilter = () => {
                msa.applyFilter();
                msa.setHashFromFilter();
            };
        msa.filter[isAdd ? 'add' : 'delete'](event.target.id.substring(7));
        if (elem.currentPhoto) {
            msa.unselectPhoto(elem.currentPhoto, doFilter);
        } else {
            doFilter();
        }
        if (!isAdd) {
            const mapPhoto = document.querySelector('.map-photo');
            if (mapPhoto && ![...mapPhoto.classList].filter(tag => msa.filter.has(tag)).length) {
                msa.map.closePopup();
            }
        }
    }
});

elem.icons.menu.addEventListener('click', event => {
    elem.menu.classList.toggle('show');
    elem.icons.menu.classList.toggle('flip');
});

for (let el of document.querySelectorAll('.photo-tags')) {
    el.addEventListener('click', event => {
        event.stopPropagation();
    });
    el.addEventListener('change', event => {
        event.stopPropagation();
        photos[event.target.parentNode.id].Tags = event.target.value.split(' ');
    });
}

elem.icons.toggle.addEventListener('click', event => {
    event.stopPropagation();
    const isMapIcon = elem.icons.toggle.classList.toggle('map-icon'),
            section = isMapIcon ? 'photos' : 'map';
    if (elem.currentPhoto) {
        const photo = elem.currentPhoto.id.substring(6),
            isPopup = msa.markers[photo]._popup.isOpen();
        if (section === 'photos') {
            msa.setExif(photo);
            isPopup || msa.map.closePopup();
            msa.showInFooter('exif');
        } else if (!isPopup) {
            msa.showInFooter('nav');
        }
    } else if (section === 'photos') {
        msa.map.closePopup();
    }
    msa.changeSection(section);
});

[...document.querySelectorAll('.nav-item')].forEach(navItem => {
    navItem.addEventListener('click', function (event) {
        event.stopPropagation();
        const section = this.id.substring(4);
        msa.changeSection(section);
    });
});

msa.map.on('popupopen', event => {
    const photoId = event.popup._contentNode.childNodes[0].id.substring(10);
    msa.setExif(photoId);
    msa.showInFooter('exif');
});

msa.map.on('popupclose', event => {
    msa.showInFooter('nav');
});

window.onhashchange = event => {
    if (!msa.isAutoHashChange) {
        msa.setFilterFromHash();
        msa.setMenuFromFilter();
        msa.applyFilter();
    }
    msa.isAutoHashChange = false;
};

window.onpopstate = event => {
    if (event.state) {
        let section = event.state.section;
        msa.sections[section] || (section = 'photos');
        msa.changeSection(section);
    }
};

window.onresize = msa.resize;
